export default {
  methods: {
    updateQuarter(wave) {
      if (!wave) return;
      if (_.includes(wave.Name, 'Q1')) wave.quarter = 'Q1';
      else if (_.includes(wave.Name, 'Q2')) wave.quarter = 'Q2';
      else if (_.includes(wave.Name, 'Q3')) wave.quarter = 'Q3';
      else if (_.includes(wave.Name, 'Q4')) wave.quarter = 'Q4';
      else if (_.includes(wave.Name, 'T1')) wave.quarter = 'T1';
      else if (_.includes(wave.Name, 'T2')) wave.quarter = 'T2';
      else if (_.includes(wave.Name, 'T3')) wave.quarter = 'T3';
    },

    getWaveList() {
      let waves = [];
      for (const board of this.dashdata) {
        if (board.OverallByWave && board.OverallByWave[0] && board.OverallByWave[0].SurveyWave) {
          for (const wave of board.OverallByWave[0].SurveyWave) {
            this.updateQuarter(wave);
            let item = _.find(waves, function(x) { return x.Year == wave.Year && x.quarter == wave.quarter });
            if (!item) {
              waves.push(wave);
            }
          }
        }
      }
      return waves;
    },
  }
};
